<template>
 <div>
    <!-- <AppDrawer v-if="$vuetify.breakpoint.mdAndUp"></AppDrawer>
    <AppDrawerMobile :show-drawer="showDrawer" v-if="$vuetify.breakpoint.smAndDown"></AppDrawerMobile>
    <AppToolbar @side-icon-click="handleDrawerVisiable"></AppToolbar>     -->
    <AppToolbar @side-icon-click="handleDrawerVisiable"></AppToolbar>    
    <AppDrawer :show-drawer="showDrawer"></AppDrawer>
    <v-main>
      <v-container fluid class="pa-6">
        <v-row no-gutters>
          <v-col cols="12" sm="12">           
            <router-view :key="$route.path"></router-view>
          </v-col>
        </v-row>
      </v-container>      
    </v-main>
  </div>
</template>

<script>

import AppDrawer from '@/components/AppDrawer.vue';
import AppToolbar from '@/components/AppToolbar.vue';


export default {
  name: "DefaultLayout",
  components:{
    AppDrawer, AppToolbar
  },
  data() {
    return {
      showDrawer: true
    }
  },
  methods:{
    handleDrawerVisiable(){      
      this.showDrawer = !this.showDrawer
    }
  }
}
</script>